import { useEffect } from 'react'

/**
 * Injects FAQPage JSON-LD into document head for SEO / rich results.
 * Removes the script when jsonLdString is empty (e.g. leaving the marketing pages).
 */
export function FaqJsonLd({ id = 'pds-faq-jsonld', jsonLdString }) {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined
    const existing = document.getElementById(id)
    if (!jsonLdString) {
      existing?.remove()
      return undefined
    }
    let el = existing
    if (!el) {
      el = document.createElement('script')
      el.id = id
      el.type = 'application/ld+json'
      document.head.appendChild(el)
    }
    el.textContent = jsonLdString
    return () => {
      el?.remove()
    }
  }, [id, jsonLdString])
  return null
}
